import React from 'react';
import PropTypes, { InferProps } from 'prop-types';

import classnames from 'classnames/bind';

import BasicButton from '@COMPONENTS/COMMON/buttons/BasicButton';

import styles from './SaveAndPublishPairButtons.module.scss';

const cx: CX = classnames.bind(styles);

function SaveAndPublishPairButtons(props: Props) {
    const {
        isSaveProcessing,
        disablePublish,
        disableSave = false,
        onSaveClick,
        onSaveAndPublishClick,
        canEditDocument,
        canPublishDocument,
    } = props;

    return (
        <div className={cx('save-and-publish-pair-buttons')}>
            <div className={cx('button-wrapper', 'save')}>
                <BasicButton
                    locked={!canEditDocument}
                    title="Save"
                    variant="success"
                    size="medium"
                    isProcessing={isSaveProcessing}
                    style={disableSave ? { 
                        opacity: 0.6, 
                        pointerEvents: 'none',
                        cursor: 'not-allowed'
                    } : {}}
                    onClick={() => {
                        if (!disableSave) {
                            onSaveClick();
                        }
                    }}
                />
            </div>

            <div className={cx('button-wrapper', 'save-and-publish')}>
                <BasicButton
                    locked={!canPublishDocument || disablePublish}
                    title="Save & Publish"
                    variant="warning"
                    size="medium"
                    style={disableSave ? { 
                        opacity: 0.6, 
                        pointerEvents: 'none',
                        cursor: 'not-allowed'
                    } : {}}
                    onClick={() => {
                        if (!disablePublish && !disableSave) {
                            onSaveAndPublishClick();
                        }
                    }}
                />
            </div>
        </div>
    );
}

SaveAndPublishPairButtons.propTypes = {
    isSaveProcessing: PropTypes.bool.isRequired,
    disablePublish: PropTypes.bool.isRequired,
    disableSave: PropTypes.bool,
    onSaveClick: PropTypes.func.isRequired,
    onSaveAndPublishClick: PropTypes.func.isRequired,
    canEditDocument: PropTypes.bool.isRequired,
    canPublishDocument: PropTypes.bool.isRequired,
};

SaveAndPublishPairButtons.defaultProps = {
    disableSave: false,
};

type Props = InferProps<typeof SaveAndPublishPairButtons.propTypes>;

export default SaveAndPublishPairButtons;
